export const CR_API_KEY = "rwuy6434tgdgjhtiojiosi838tjue3";